<script lang="ts" setup>
import type { ErrorCause } from "@lxc/app-device-common";
import type LxcError from "~/core/models/LxcError.class";
import { setDetailMessageAsListItem } from "~/core/utils/notifications";
import ILxcAlertCircle from "~icons/lxc/alert-circle";

const { t } = useI18n();
const props = defineProps<{
  error?: LxcError;
}>();

const titleKey = "errors.httpStatusCodes.500.title";
const subtitleKey = "errors.httpStatusCodes.500.subtitle";

const errorTranslation = computed(() => {
  let title = t(titleKey);
  let subtitle = t(subtitleKey);

  if (props.error) {
    const error: Error = props.error?.toError(titleKey);

    if ((error.cause as ErrorCause).values) {
      title = error.message;
      subtitle = (error.cause as ErrorCause).values
        .map(setDetailMessageAsListItem)
        .join("");
    } else {
      title = error.message;
      subtitle = (error.cause as unknown as string) ?? undefined;
    }
  }

  return {
    title,
    subtitle,
  };
});
</script>

<template>
  <lxc-alert type="error" :icon="ILxcAlertCircle">
    <template #title>
      {{ errorTranslation.title }}
    </template>

    <template #default>
      {{ errorTranslation.subtitle }}
    </template>
  </lxc-alert>
</template>
